<template>
    <div id="delete-prompt" @click="deletePrompt">
        <span>{{ prompt }}</span>
        <i class="fa fa-times ml-1"></i>
    </div>
</template>
<script>
import PromptEditorManager from '../../../manager/PromptEditorManager';
import store from '../../../mixins/store.mixin';
import currentJob from '../../../mixins/current_job.mixin';
import Analytics from "../../../util/Analytics";

export default {
    name: 'DeletePrompt',
    props: { prompt: String },
    data() {
        return {};
    },
    mixins: [store, currentJob],
    methods: {
        deletePrompt() {
          Analytics.send('creator_studio_action', `prompt_delete`, this.currentJob);
          PromptEditorManager.deletePrompt(this.prompt);
        },
    },
};
</script>
<style scoped>
#delete-prompt {
    background-color: #1266f1;
    box-sizing: border-box;
    min-height: 30px;
    width: auto;
    border-radius: 9px;
    padding: 3px 10px 3px 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
}
</style>
